import { render, staticRenderFns } from "./vsChips.vue?vue&type=template&id=67594da9&lang=html"
import script from "./vsChips.vue?vue&type=script&lang=js"
export * from "./vsChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports